export const ExistingDamageDetailsColumns = {
  GROUP_SELECTED: 'group-selected',
  SELECTED: 'selected',
  // Assets
  GROUP_EXISTING_GAMAGE: 'group-existing-damage',

  GROUP_STATUS: 'group-status',
  STATUS: 'status',

  GROUP_CATEGORY: 'group-category',
  CATEGORY: 'category',

  GROUP_COMPONENT: 'group-component',
  COMPONENT: 'component',

  GROUP_LOCATION: 'group-location',
  LOCATION: 'location',

  GROUP_PART: 'group-part',
  PART: 'part',

  GROUP_DAMAGE: 'group-damage',
  DAMAGE: 'damage',

  GROUP_CREATION_DATE: 'group-creation-date',
  CREATION_DATE: 'creationDate',
};

export const ExistingDamageDetailsColumnDefs = {
  [ExistingDamageDetailsColumns.GROUP_SELECTED]: {
    locked: true,
    cols: {
      [ExistingDamageDetailsColumns.SELECTED]: {
        labels: [
          {
            a11yKey: 'table.attach_damage',
            a11yDefault: 'Attach damage',
          },
        ],
        cell: {
          align: 'center',
          width: '30px',
        },
      },
    },
  },
  [ExistingDamageDetailsColumns.GROUP_STATUS]: {
    locked: true,
    align: 'center',
    cols: {
      [ExistingDamageDetailsColumns.STATUS]: {
        align: 'left',
        labels: [
          {
            align: 'center',
            a11yKey: 'table.status',
            a11yDefault: 'Status',
          },
        ],
        cell: {
          width: '30px',
          minWidth: '30px',
        },
      },
    },
  },
  [ExistingDamageDetailsColumns.GROUP_CATEGORY]: {
    locked: true,
    cols: {
      [ExistingDamageDetailsColumns.CATEGORY]: {
        labels: [
          {
            a11yKey: 'table.category',
            a11yDefault: 'Category',
          },
        ],
        cell: {
          width: '30px',
          minWidth: '30px',
        },
      },
    },
  },
  [ExistingDamageDetailsColumns.GROUP_COMPONENT]: {
    locked: true,
    cols: {
      [ExistingDamageDetailsColumns.COMPONENT]: {
        align: 'left',
        labels: [
          {
            a11yKey: 'table.component',
            a11yDefault: 'Component',
          },
        ],
        cell: {
          width: '40px',
          maxWidth: '40px',
        },
      },
    },
  },
  [ExistingDamageDetailsColumns.GROUP_LOCATION]: {
    locked: true,
    cols: {
      [ExistingDamageDetailsColumns.LOCATION]: {
        align: 'left',
        labels: [
          {
            a11yKey: 'table.location',
            a11yDefault: 'Location',
          },
        ],
        cell: {
          maxWidth: '90px',
        },
      },
    },
  },
  [ExistingDamageDetailsColumns.GROUP_PART]: {
    locked: true,
    cols: {
      [ExistingDamageDetailsColumns.PART]: {
        align: 'left',
        labels: [
          {
            a11yKey: 'table.part',
            a11yDefault: 'Part',
          },
        ],
        cell: {
          maxWidth: '90px',
        },
      },
    },
  },
  [ExistingDamageDetailsColumns.GROUP_DAMAGE]: {
    locked: true,
    cols: {
      [ExistingDamageDetailsColumns.DAMAGE]: {
        align: 'left',
        labels: [
          {
            a11yKey: 'table.damage',
            a11yDefault: 'Damage',
          },
        ],
        cell: {
          maxWidth: '100px',
        },
      },
    },
  },
  [ExistingDamageDetailsColumns.GROUP_CREATION_DATE]: {
    locked: true,
    cols: {
      [ExistingDamageDetailsColumns.CREATION_DATE]: {
        align: 'left',
        labels: [
          {
            a11yKey: 'table.creationDate',
            a11yDefault: 'Creation Date',
          },
        ],
        cell: {
          width: '50px',
          minWidth: '50px',
        },
      },
    },
  },
};

export const defaultExistingDamageDetailsCols = [
  {
    id: ExistingDamageDetailsColumns.GROUP_SELECTED,
    cols: [
      {
        id: ExistingDamageDetailsColumns.SELECTED,
        visible: true,
      },
    ],
  },
  {
    id: ExistingDamageDetailsColumns.GROUP_STATUS,
    cols: [
      {
        id: ExistingDamageDetailsColumns.STATUS,
        visible: true,
      },
    ],
  },
  {
    id: ExistingDamageDetailsColumns.GROUP_CATEGORY,
    cols: [
      {
        id: ExistingDamageDetailsColumns.CATEGORY,
        visible: true,
      },
    ],
  },
  {
    id: ExistingDamageDetailsColumns.GROUP_COMPONENT,
    cols: [
      {
        id: ExistingDamageDetailsColumns.COMPONENT,
        visible: true,
      },
    ],
  },
  {
    id: ExistingDamageDetailsColumns.GROUP_LOCATION,
    cols: [
      {
        id: ExistingDamageDetailsColumns.LOCATION,
        visible: true,
      },
    ],
  },
  {
    id: ExistingDamageDetailsColumns.GROUP_PART,
    cols: [
      {
        id: ExistingDamageDetailsColumns.PART,
        visible: true,
      },
    ],
  },
  {
    id: ExistingDamageDetailsColumns.GROUP_DAMAGE,
    cols: [
      {
        id: ExistingDamageDetailsColumns.DAMAGE,
        visible: true,
      },
    ],
  },
  {
    id: ExistingDamageDetailsColumns.GROUP_CREATION_DATE,
    cols: [
      {
        id: ExistingDamageDetailsColumns.CREATION_DATE,
        visible: true,
      },
    ],
  },
];
